<template>
  <a-card>
    <a-card-grid v-for="item in platforms" :key="item.value"
      :class="`click ${platform === item.value ? 'pactive' : ''}`" style="width:20%;text-align:center;" hoverable
      @click="changePlatform(item.value)">
      <span class="text-h6">{{ item.label }}</span>
    </a-card-grid>
  </a-card>
  <a-table size="small" :columns="columns1" bordered :data-source="data1" :loading="dataLoading1"
    :scroll="{ x: width1, y: 600 }"
    :pagination="{ current: page1, pageSize: limit1, total: count1, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page1 = pagination.current; limit1 = pagination.pageSize; }">
    <template #title>
      <div class="d-flex justify-space-between align-center mb-2">
        <a-space>
          <a-button type="primary" @click="add(1)">
            <template #icon>
              <PlusOutlined />
            </template>
            新增主账户
          </a-button>
          <a-button type="link" @click="getData1">刷新数据</a-button>
        </a-space>
      </div>
    </template>
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a href="javascript:;" @click="edit(1, record)">编辑</a>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-table size="small" :columns="columns2" bordered :data-source="data2" :loading="dataLoading2"
    :scroll="{ x: width2, y: 600 }"
    :pagination="{ current: page2, pageSize: limit2, total: count2, showQuickJumper: true, showSizeChanger: true, showTotal: (total) => `共${total}条`, }"
    @change="(pagination) => { page2 = pagination.current; limit2 = pagination.pageSize; }">
    <template #title>
      <div class="d-flex justify-space-between align-center mb-2">
        <a-space>
          <a-button type="primary" @click="add(2)">
            <template #icon>
              <PlusOutlined />
            </template>
            新增子账户
          </a-button>
          <a-button type="link" @click="getData2">刷新数据</a-button>
        </a-space>
      </div>
    </template>
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'orgid'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a href="javascript:;" @click="edit(2, record)">编辑</a>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="dataModal" :title="dataModalTitle" :maskClosable="!saving" :closable="!saving">
    <template #footer>
      <div class="d-flex justify-end align-center">
        <a-space>
          <a-checkbox v-if="dataForm._id === ''" v-model:checked="continue_add">连续添加</a-checkbox>
          <a-button type="default" @click="cancelSave" :disabled="saving">取消</a-button>
          <a-button type="primary" @click="save" :loading="saving">确认</a-button>
        </a-space>
      </div>
    </template>
    <a-form ref="dataFormRef" name="dataForm" :model="dataForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <!--#region 主账户 -->
        <template v-if="type === 1">
          <a-col :span="24">
            <a-form-item label="主账户号码" name="master_account_number" :rules="[{ required: true, message: '请输入主账户号码' }]">
              <a-input v-model:value="dataForm.master_account_number" placeholder="主账户号码" :disabled="saving">
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="主账户名称" name="master_account_name" :rules="[{ required: true, message: '请输入主账户名称' }]">
              <a-input v-model:value="dataForm.master_account_name" placeholder="主账户名称" :disabled="saving">
              </a-input>
            </a-form-item>
          </a-col>
        </template>
        <!--#endregion 主账户 -->
        <!--#region 子账户 -->
        <template v-if="type === 2">
          <a-col :span="24">
            <a-form-item label="商户" name="orgid" :rules="[{ required: true, message: '请选择商户' }]">
              <a-select v-model:value="dataForm.orgid" :options="sorgs" :filter-option="$filters.filterOption"
                show-search placeholder="请选择">
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="platform === '连连'">
            <a-col :span="24">
              <a-form-item label="收款账号" name="receive_account_number" :rules="[{ required: true, message: '请输入收款账号' }]">
                <a-input v-model:value="dataForm.receive_account_number" placeholder="收款账号" :disabled="saving">
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="店铺名称" name="shop_name" :rules="[{ required: true, message: '请输入店铺名称' }]">
                <a-input v-model:value="dataForm.shop_name" placeholder="店铺名称" :disabled="saving">
                </a-input>
              </a-form-item>
            </a-col>
          </template>
          <template v-else>
            <a-col :span="24">
              <a-form-item label="子账户号码" name="sub_account_number" :rules="[{ required: true, message: '请输入子账户号码' }]">
                <a-input v-model:value="dataForm.sub_account_number" placeholder="子账户号码" :disabled="saving">
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="子账户名称" name="sub_account_name" :rules="[{ required: true, message: '请输入子账户名称' }]">
                <a-input v-model:value="dataForm.sub_account_name" placeholder="子账户名称" :disabled="saving">
                </a-input>
              </a-form-item>
            </a-col>
          </template>
        </template>
        <!--#endregion 子账户 -->
      </a-row>
    </a-form>
  </a-modal>
</template>
<script setup>
import { PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, onActivated, getCurrentInstance, nextTick, } from "vue";
import _ from "underscore";
const columns1 = [
  { title: '主账户号码', dataIndex: 'master_account_number', width: 150 },
  { title: '主账户名称', dataIndex: 'master_account_name', width: 150 },
  { title: '创建时间', dataIndex: 'create_time', width: 150, },
  { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
];

const { proxy } = getCurrentInstance();
const dataFormRef = ref();

const platforms = [
  { value: '艾贝盈', label: '艾贝盈' },
  { value: '连连', label: '连连' },
  { value: 'PingPong', label: 'PingPong' },
  { value: '万里汇', label: '万里汇' },
  { value: '派安盈', label: '派安盈' },
];
const platform = ref("艾贝盈");
const orgs = ref([]);
const dataLoading1 = ref(false);
const page1 = ref(1);
const limit1 = ref(20);
const length1 = ref(0);
const count1 = ref(0);
const data1 = ref([]);
const dataLoading2 = ref(false);
const page2 = ref(1);
const limit2 = ref(20);
const length2 = ref(0);
const count2 = ref(0);
const data2 = ref([]);
const type = ref(1);
const dataForm = ref({});
const dataModalTitle = ref('');
const dataModal = ref(false);
const saving = ref(false);
const continue_add = ref(false);

const columns2 = computed(() => {
  return [
    { title: '商户', dataIndex: 'orgid', width: 150 },
    ...(
      (platform.value === '连连') ? [
        { title: '收款账号', dataIndex: 'receive_account_number', width: 150 },
        { title: '店铺名称', dataIndex: 'shop_name', width: 150 },
      ] : [
        { title: '子账户号码', dataIndex: 'sub_account_number', width: 150 },
        { title: '子账户名称', dataIndex: 'sub_account_name', width: 150 },
      ]
    ),
    { title: '创建时间', dataIndex: 'create_time', width: 150, },
    { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }
  ];
});

const width1 = computed(() => proxy.$utils.twidth(columns1));
const width2 = computed(() => proxy.$utils.twidth(columns2.value));
const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));

watch(() => page1.value, () => {
  getData1();
});
watch(() => limit1.value, () => {
  if (page1.value !== 1) page1.value = 1;
  else getData1();
});
watch(() => page2.value, () => {
  getData2();
});
watch(() => limit2.value, () => {
  if (page2.value !== 1) page2.value = 1;
  else getData2();
});

onMounted(() => {
  init();
});
const init = () => {
  getData1();
  getData2();
}
const changePlatform = (value) => {
  platform.value = value;
  nextTick(() => {
    init();
  })
}
const getData1 = () => {
  dataLoading1.value = true;
  proxy.$api.doAPI("/platformaccount/list", { page: page1.value, limit: limit1.value, platform: platform.value, type: 1 }).then((res) => {
    dataLoading1.value = false;
    if (res.code === 0) {
      data1.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length1.value = res.data.length;
      count1.value = res.data.count;
      if (length1.value > 0 && page1.value > length1.value) page1.value = 1;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading1.value = false;
    console.error(err);
  });
};
const getData2 = () => {
  dataLoading2.value = true;
  proxy.$api.doAPI("/platformaccount/list", { page: page2.value, limit: limit2.value, platform: platform.value, type: 2 }).then((res) => {
    dataLoading2.value = false;
    if (res.code === 0) {
      data2.value = _.map(res.data.list, n => {
        return {
          ...n,
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
        }
      });
      length2.value = res.data.length;
      count2.value = res.data.count;
      if (length2.value > 0 && page2.value > length2.value) page2.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading2.value = false;
    console.error(err);
  });
};
const initForm = (type) => {
  if (type === 1) {
    return {
      _id: "",
      master_account_number: "",
      master_account_name: "",
    };
  }
  if (type === 2) {
    return {
      _id: "",
      orgid: null,
      sub_account_number: "",
      sub_account_name: "",
      receive_account_number: "",
      shop_name: "",
    };
  }
};
const add = (value) => {
  type.value = value;
  if (value === 1) {
    dataForm.value = initForm(value);
    dataModalTitle.value = '新增主账户';
  }
  if (value === 2) {
    dataForm.value = initForm(value);
    dataModalTitle.value = '新增子账户';
  }
  dataModal.value = true;
}
const edit = (value, item) => {
  type.value = value;
  if (value === 1) {
    dataForm.value = _.pick(item, _.keys(initForm(1)));
    dataModalTitle.value = '编辑主账户';
  }
  if (value === 2) {
    dataForm.value = _.pick(item, _.keys(initForm(2)));
    dataModalTitle.value = '编辑子账户';
  }
  dataModal.value = true;
}
const save = async () => {
  try {
    await dataFormRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/platformaccount/save", { dataForm: dataForm.value, platform: platform.value, type: type.value }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        dataModal.value = continue_add.value;
        if (type.value === 1) getData1();
        if (type.value === 2) getData2();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => {
  dataFormRef.value.clearValidate();
  dataModal.value = false;
  continue_add.value = false;
};
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

.pactive {
  background: #e6f7ff;
  color: #1890ff;
}

p {
  margin: 0;
  padding: 0;
}
</style>